export const HELP_CENTER_TABS = ["guides", "updates", "media", "snippets"] as const;

/** Zakładka listy dla danego rodzaju materiału: powrót z edycji ląduje tam, skąd się przyszło. */
export const helpCenterListPath = (kind: string) => `/help-center?tab=${kind === "update" ? "updates" : "guides"}`;
